import React, { useLayoutEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { IGetPhytophagyStressRiskDataResModel } from '@/util/Request/agrialert/responseType';
import { HeatOrColdStressRiskEnum } from '@/page/Agrialert/template-management/template-management';
import internal from 'stream';

const HeatColor = {
    LOW: '#FFDCE0',
    Med: '#F6B7B8',
    High: '#ef7878',
    White: 'white',
};
const ColdColor = {
    LOW: '#E9FDFF',
    Med: '#B1EBFF',
    High: '#7bbde7',
    White: 'white',
};

interface IProp {
    id: string;
    echartData: IGetPhytophagyStressRiskDataResModel[];
    heatOrColdType: HeatOrColdStressRiskEnum;
}

const TemplateStressChart = (prop: IProp) => {

    const { id, echartData, heatOrColdType } = prop;

    console.log('template-stress-chart echartData', echartData);

    const getEchartsOptions = () => {

        const tmpXAxisData = echartData?.[0]?.finalDate;
        const tmpSeries = echartData?.map((item)=>{
            return {
                name: item?.cropName,
                type: 'line',
                data: item?.finalRecommendationValues,
                yAxisIndex: 0,
                markArea: {
                    silent: true, // 设置为 true 以防止点击或悬停时触发其他事件
                    itemStyle: {
                        color: 'rgba(0,0,0,0.1)' // 设置透明度以模拟背景色效果
                    },
                    data: [
                        // 0-1 area's color is green
                        [{yAxis: 0}, {yAxis: 3, itemStyle: {color: heatOrColdType === HeatOrColdStressRiskEnum.HEATSTRESSRISK ?
                            HeatColor.LOW : ColdColor.LOW,opacity: '0.4'}}],
                        // 1-2 area's color is yellow
                        [{yAxis: 3}, {yAxis: 6, itemStyle: {color: heatOrColdType === HeatOrColdStressRiskEnum.HEATSTRESSRISK ?
                            HeatColor.Med : ColdColor.Med,opacity:'0.4'}}],
                        // 2-3 area's color is orange
                        [{yAxis: 6}, {yAxis: 20, itemStyle: {color: heatOrColdType === HeatOrColdStressRiskEnum.HEATSTRESSRISK ?
                            HeatColor.High : ColdColor.High ,opacity:'0.4'}}],
                    ]
                }
            };
        });

        const echartsOptions = {
            // title :{
            //     name : 'Stress Risk',
            // },
            grid: {
                containLabel: false,
                left: '4%',
                width: '96%',
                top: 10,
                height: 150,
            },
            tooltip: {
                trigger: 'axis', // 触发方式：坐标轴触发
            },
            legend: {
                data: echartData?.map((item => item?.cropName)), // 图例数据
                top: '180', // 图例位置
            },
            xAxis: {
                type: 'category',
                data: tmpXAxisData, // X 轴数据
                interval: 1,
                axisTick: {
                    show: true,
                    inside: false
                }
            },
            yAxis: [
                {
                    type: 'value',
                    name: '', // 左侧 Y 轴名称
                    min: 0,
                    max: 9,
                    interval: 3,
                    axisTick: {
                        show: true,
                        alignWithLabel: true
                    },
                    splitNumber: 3
                }
            ],
            series: tmpSeries,
        };

        return echartsOptions;
    };

    const forecastChartRef = useRef<HTMLDivElement>(null);
    useLayoutEffect(() => {
        if (echartData?.length >= 1) {
            const initChart = () => {
                if (forecastChartRef.current) {
                    const forecastChart = echarts.init(forecastChartRef.current);
                    const echartsOptions = getEchartsOptions();
                    forecastChart.setOption(echartsOptions);
                    console.log('lanxue value echartsOptions',echartsOptions);
                }
            };

            // 使用 requestAnimationFrame 确保 DOM 更新后执行
            requestAnimationFrame(initChart);

            return () => {
                // 清理函数，确保图表被销毁
                if (forecastChartRef.current) {
                    const chartInstance = echarts.getInstanceByDom(forecastChartRef.current);
                    if (chartInstance) {
                        chartInstance.dispose();
                    }
                }
            };
        }
    }, [echartData]);

    return(
        <div>
            <div id={id}
                ref={forecastChartRef}
                style={{width:'822px',height:`${220}px`}}></div>
        </div>

    );
};

export default React.memo(TemplateStressChart);